import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';

interface FormGroupProps {
    className?: string;
    label?: string;
    required?: boolean;
}

@observer export class FormGroup extends Component<FormGroupProps, any> {

    render() {
        const { className, label, required } = this.props;

        return <div className={`form-group col-12${className ? ' ' + className : ''}`}>
            { label && <label>{ label } { required && <i className={'required'} /> }</label> }

            { this.props.children }
        </div>
    }

}
